import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { LOST_REASONS } from "../lib/constants";

export const LostReasonFields = ({ reason, note, onChange, prefix = "lost" }) => (
  <div className="space-y-3">
    <div>
      <Label>Reason lost</Label>
      <Select value={reason || undefined} onValueChange={(v) => onChange({ reason: v, note })}>
        <SelectTrigger className="mt-1" data-testid={`${prefix}-reason-select`}><SelectValue placeholder="Pick a reason" /></SelectTrigger>
        <SelectContent>{LOST_REASONS.map((r) => <SelectItem key={r.key} value={r.key} data-testid={`${prefix}-reason-${r.key}`}>{r.label}</SelectItem>)}</SelectContent>
      </Select>
    </div>
    <div>
      <Label>{reason === "other" ? "Describe the reason" : "Note (optional)"}</Label>
      <Textarea value={note} onChange={(e) => onChange({ reason, note: e.target.value })} className="mt-1" rows={2} data-testid={`${prefix}-reason-note`} />
    </div>
  </div>
);

export const LostReasonDialog = ({ patient, onConfirm, onCancel }) => {
  const [val, setVal] = useState({ reason: "", note: "" });
  useEffect(() => { if (patient) setVal({ reason: "", note: "" }); }, [patient]);
  const invalid = !val.reason || (val.reason === "other" && !val.note.trim());
  return (
    <Dialog open={!!patient} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent data-testid="lost-reason-dialog">
        <DialogHeader><DialogTitle>Why was {patient?.name} lost?</DialogTitle></DialogHeader>
        <LostReasonFields reason={val.reason} note={val.note} onChange={setVal} />
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} data-testid="lost-reason-cancel">Cancel</Button>
          <Button disabled={invalid} onClick={() => onConfirm(val.reason, val.note)} className="bg-ccc-rose hover:bg-rose-600 text-white" data-testid="lost-reason-confirm">Mark lost</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
